var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBusiness(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_104_31)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.7651 30H12.4214C11.2582 30 10.312 29.0538 10.312 27.8906V13.3594C10.312 12.1962 11.2582 11.25 12.4214 11.25H14.7651C15.9283 11.25 16.8745 12.1962 16.8745 13.3594V27.8906C16.8745 29.0538 15.9282 30 14.7651 30Z",
    fill: "#FF82AC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.85889 30H3.51514C2.35199 30 1.40576 29.0538 1.40576 27.8906V18.0469C1.40576 16.8837 2.35199 15.9375 3.51514 15.9375H5.85889C7.02204 15.9375 7.96827 16.8837 7.96827 18.0469V27.8906C7.96827 29.0538 7.02198 30 5.85889 30Z",
    fill: "#FF82AC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6714 30H21.3276C20.1645 30 19.2182 29.0538 19.2182 27.8906V8.4375H17.9304C17.3282 8.4375 16.7979 8.09766 16.5463 7.55062C16.2946 7.00359 16.3818 6.3798 16.7737 5.9226C16.7781 5.91738 16.7827 5.91217 16.7872 5.90707L21.8013 0.311836C21.9791 0.113379 22.233 0 22.4995 0C22.766 0 23.0198 0.113379 23.1977 0.311836L28.2118 5.90707C28.2164 5.91217 28.2209 5.91738 28.2254 5.9226C28.6172 6.37975 28.7044 7.00359 28.4528 7.55062C28.2012 8.09766 27.6708 8.4375 27.0687 8.4375H25.7808V27.8906C25.7808 29.0538 24.8345 30 23.6714 30Z",
    fill: "#FF82AC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_104_31"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusiness);
export default __webpack_public_path__ + "static/media/business.36c796408aee665b94c7bfa80ac8ad34.svg";
export { ForwardRef as ReactComponent };